import { ICurbsideNotification, IResponseCurbsideNotification } from '../types';

export const curbsideNotificationCast = (data: IResponseCurbsideNotification): ICurbsideNotification => {
  return {
    subject: { en: data.curbside_sms_title_en, ar: data.curbside_sms_title_ar },
    message: { en: data.curbside_sms_textarea_en, ar: data.curbside_sms_textarea_ar },
  };
};

export const getCurbsideNotificationParams = (data: ICurbsideNotification): IResponseCurbsideNotification => {
  return {
    curbside_sms_title_en: data.subject.en,
    curbside_sms_title_ar: data.subject.ar,
    curbside_sms_textarea_en: data.message.en,
    curbside_sms_textarea_ar: data.message.ar,
  };
};
